import { notification } from 'antd'

interface IUseMessage {
  success(msg: string, title?: string): void
  error(msg: string, title?: string): void
}

export const useMessage = (): IUseMessage => {
  notification.config({
    placement: 'bottomLeft',
    getContainer: () => document.getElementById('App') || document.body,
  })

  const success = (msg?: string, title?: string) => {
    notification.success({
      message: title ?? 'Выполнено',
      description: msg ?? '',
      duration: 5,
      placement: 'bottomLeft',
    })
  }

  const error = (msg: string, title?: string) => {
    notification.error({
      message: title ?? 'Возникла ошибка',
      description: msg ?? '',
      duration: 5,
      placement: 'bottomLeft',
    })
  }

  return { success, error }
}
